/** Enables v2 of the surgery details drawer */
export const SURGERY_DETAILS_V2_FLAG = 'surgery_details_v2';

/** Shows the surgery details drawer. It is superceeded by IS_DEMO_FLAG or SURGERY_DETAILS_V2_FLAG */
export const SHOW_SURGERY_DETAILS_DRAWER_FLAG = 'show_surgery_details_drawer';

/** Enables the ability to delete surgeries */
export const CAN_DELETE_SURGERY_FLAG = 'can_delete_surgery';

/** Enables demo functionality */
export const IS_DEMO_FLAG = 'is_demo';

/** Disabled all features outside of mission control */
export const MISSION_CONTROL_ONLY_FLAG = 'mission_control_only';

export const STAGES_AUTO_SCROLL = 'stages_auto_scroll';
